"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFuturesIndexOnce = void 0;
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
/** 请求合约index的rest接口 */
const queryFuturesIndexOnce = (symbol) => {
    return (0, FutureAPI_1.getFutureMarketIndexes)([symbol]).pipe((0, operators_1.map)((res) => {
        if (res === null || res === void 0 ? void 0 : res.length) {
            const item = res[0];
            const arr = item.symbol.split("/");
            const base = arr[0] || "";
            const quote = arr[1] || "";
            return Object.assign(Object.assign({}, item), { base: base, quote: quote });
        }
        else {
            throw { code: -1, message: "no indexs" };
        }
    }));
};
exports.queryFuturesIndexOnce = queryFuturesIndexOnce;
